export class SaveInspectionDecisionDto {
  type: string;
  inspectionRegistrationReportId: number;
  inspectionResultId: number;
  finalDecisionId: number;
  finalDecisionCourseId: number;
  finalDecisionAssessmentId: number;
  validFrom: Date;
  validTo: Date;
  validFromCourse: Date;
  validToCourse: Date;
  validFromAssessment: Date;
  validToAssessment: Date;
}